import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import { Select as SerendieSelect } from "@serendie/ui";
import "./Styles.scss";
import { Guid } from "@iconics/core";

export class Select extends BaseComponent<ISelectProps, ISelectState>
{
    private inputId = Guid.new().toString().toLowerCase();
    public static requiredLabel = '*';

    private handleOpenChange(details: ISelectOpenChangeDetails): void
    {
        const popper = document.getElementById(`select:${this.inputId}:positioner`);
        if (popper && !popper.classList.contains('serendie-select__popper'))
        {
            popper.classList.add('serendie-select__popper');
        }
        this.props.onOpenChange?.(details);
    }

    public render(): JSX.Element
    {
        const SerendieSelectWithRef = SerendieSelect as React.FC<ISerendieProps>;

        return (
            <SerendieSelectWithRef
                id={this.inputId}
                {...this.props}
                className={`${this.props.className ?? ''} serendie-select`}
                onOpenChange={e => this.handleOpenChange(e)}
                requiredLabel={Select.requiredLabel ?? this.props.requiredLabel}
            />
        )
    }
}

export interface ISelectProps extends ISerendieProps { }

interface ISerendieProps extends Omit<React.ComponentProps<typeof SerendieSelect>, 'collection'>
{
    ref?: React.Ref<any>;
}

export interface ISelectState
{
}

export interface ISelectOpenChangeDetails
{
    open: boolean;
    value: string[];
}

export interface ISelectItem
{
    value: string;
    label: string;
}
